export default {
  DRAFT: "draft",
  ACTIVE: "active",
  INACTIVE: "inactive",
};
